/**
 * Created by prog2 on 25/10/2018.
 */

export default {
  message: {
    title: 'KATEDRA W WALENCJI',
    preferVisitRead: 'Prefiero leer',
    preferVisitListten: 'Prefiero escuchar',
    downloadAudio: '(Downloading)',
    download:'Descargando',
    errorDownload: 'Error en la descarga.',
    cancelDownload: 'Has cancelado la descarga.',
    initDownload: 'Proszę czekać na załadowanie ścieżki dźwiękowej',
    endDownload: 'Ścieżka dźwiękowa załadowana. Życzymy miłego zwiedzania!',
    retry: 'Reintentar',
    noConnection: 'No tienes conexión a internet',
    titleMap: '',
    map: 'Plano1.png',
    menuItems: [
      {
        idImages: 1,
        title: 'Witamy',
        author: 'Prosimy o założenie słuchawek',
        description: '',
        // audio: require('./../../assets/audio/ESP/1.mp3')
        audio: '1.mp3'
      },
      {
        idImages: 2,
        title: 'Kaplica świętego Sebastiana',
        author: 'Tylna część nawy',
        description: '',
        audio: '2.mp3'

      },
      {
        idImages: 3,
        title: 'Kaplica świętego Piotra Apostoła',
        author: 'Prawa nawa boczna',
        description: '',
        audio: '3.mp3'

      },
      {
        idImages: 4,
        title: 'Kaplica świętego Franciszka Borgiasza',
        author: 'Prawa nawa boczna',
        description: '',
        audio: '4.mp3'

      },
      {
        idImages: 5,
        title: 'Okno rozglifione',
        author: '',
        description: '.',
        audio: '5.mp3'

      },
      {
        idImages: 6,
        title: 'Ołtarz Główny',
        author: 'Główna kaplica',
        description: '',
        audio: '6.mp3'

      },
      {
        idImages: 7,
        title: 'Aniołowie-muzykanci',
        author: 'Główna kaplica',
        description: '',
        audio: '7.mp3'

      },
      {
        idImages: 8,
        title: 'Kopuła ołtarzowa',
        author: 'Skrzyżowanie naw',
        description: '',
        audio: '8.mp3'

      },
      {
        idImages: 9,
        title: 'Brama Jałmużny',
        author: 'Prawe ramię transeptu',
        description: '',
        audio: '9.mp3'

      },
      {
        idImages: 10,
        title: 'Ambit + Organy',
        author: 'Ambit',
        description: '',
        audio: '10.mp3'

      },
      {
        idImages: 11,
        title: 'Zmartwychwstanie',
        author: 'Kaplice ambitu',
        description: '',
        audio: '11.mp3'

      },
      {
        idImages: 12,
        title: 'Kaplica Chrystusa Dobrej Śmierci',
        author: 'Kaplice ambitu',
        description: '',
        audio: '12.mp3'

      },
      {
        idImages: 13,
        title: 'Madonna na Krześle + święty Jakub',
        author: 'Kaplice ambitu',
        description: '',
        audio: '13.mp3'

      },
      {
        idImages: 14,
        title: 'Św. Dionizy i św. Małgorzata',
        author: 'Kaplice ambitu',
        description: '',
        audio: '14.mp3'

      },
      {
        idImages: 15,
        title: 'Brama Apostołów',
        author: 'Lewe ramię transeptu',
        description: '',
        audio: '15.mp3'

      },
      {
        idImages: 16,
        title: 'Dalszy ciąg zwiedzania',
        author: 'Lewa boczna nawa',
        description: '',
        audio: '16.mp3'

      },
      {
        idImages: 17,
        title: 'Monstrancja',
        author: 'Muzeum: parter',
        description: '',
        audio: '17.mp3'

      },
      {
        idImages: 18,
        title: 'Zły łotr + Pokłon',
        author: 'Muzeum: parter',
        description: '',
        audio: '18.mp3'

      },
      {
        idImages: 19,
        title: 'Makiety',
        author: 'Muzeum: drugie piętro',
        description: '',
        audio: '19.mp3'

      },
      {
        idImages: 20,
        title: 'Apostołowie',
        author: 'Muzeum: drugie piętro',
        description: '',
        audio: '20.mp3'

      },
      {
        idImages: 21,
        title: 'Zwątpienie św. Tomasza + Zaśnięcie',
        author: 'Muzeum: drugie piętro',
        description: '',
        audio: '21.mp3'

      },
      {
        idImages: 22,
        title: 'Relikwiarz',
        author: 'Muzeum: drugie piętro',
        description: '',
        audio: '22.mp3'

      },
      {
        idImages: 23,
        title: 'Szyderstwa',
        author: 'Muzeum: drugie piętro',
        description: '',
        audio: '23.mp3'

      },
      {
        idImages: 24,
        title: 'Korytarz + Sztuka barokowa',
        author: 'Muzeum: drugie piętro',
        description: '',
        audio: '24.mp3'

      },
      {
        idImages: 25,
        title: 'Wykopaliska archeologiczne',
        author: 'Muzeum: podziemia',
        description: '',
        audio: '25.mp3'

      },
      {
        idImages: 26,
        title: 'Księgi chórowe + Ostatnia Wieczerza',
        author: 'Muzeum: parter',
        description: '',
        audio: '26.mp3'

      },
      {
        idImages: 27,
        title: 'Święty Kielich',
        author: 'Kaplica Świętego Kielicha',
        description: '',
        audio: '27.mp3'

      },
      {
        idImages: 28,
        title: 'Kaplica Świętego Kielicha',
        author: 'Kaplica Świętego Kielicha',
        description: '',
        audio: '28.mp3'

      },
      {
        idImages: 29,
        title: 'Dzwonnica Micalet',
        author: '',
        description: '',
        audio: '29.mp3'

      },
      {
        idImages: 30,
        title: 'Napisy końcowe',
        isCredits:true,
        author: '',
        description: 'Trama Media dla Katedry w Walencji.<br><br>© Katedra w Walencji, 2026.<br><br> Wszelkie prawa zastrzeżone.<br><br>',
        audio: '',
        idCreditImage: 30,
      },

    ]

  }
};



// WEBPACK FOOTER //
// ./src/data/i18n/polski.js